/**
 * ============================================
 * Internal Team Configuration
 * ============================================
 * 
 * Whitelist of internal team members who bypass plan restrictions
 * (Developers, Testers, Digital Marketers)
 */

// Add business_user_ids of internal team members here
// These users will have full Premium access regardless of their plan
export const INTERNAL_TEAM_WHITELIST = [
  // Example format:
'68be76563bbf9d4a58eb1f8c',
'68bab8583eea5035a32c83b7',
'68c2bc77c5e89514efb74e66',
'68a3fb7e4a01911b1c70a57b',
'691ff8da2ee2a1edf1ccef09'
  
  // TODO: Add your team members' business_user_ids below
  // Developers
  
  // Testers
  
  // Digital Marketers
  
];

/**
 * Helper function to check if a user is internal team
 */
export const isInternalTeamMember = (businessUserId) => {
  return INTERNAL_TEAM_WHITELIST.includes(businessUserId);
};

export default INTERNAL_TEAM_WHITELIST;
